module.exports = __webpack_public_path__ + "static/img/brees-2010-top.9ef0f49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-top.jpg
// module id = 0Lt3
// module chunks = 1